import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { isTenant as isTenantSelector } from 'features/user/selectors/userSelectors';
import { saveFilters, clearFilters } from 'features/pagination/actions/paginationActions';
import { getFilterParams } from 'features/pagination/selectors/paginationSelectors';
import { PaginationView } from 'features/pagination/models/paginationModel';
import { PaginationFilters } from 'features/pagination/reducers/paginationReducer';
import { AppState } from 'common/appState';

import { FilterDrawer } from './FilterDrawer';
import { BenefitsFilter } from './BenefitsFilter';

interface Props {
    visible: boolean;
    onClose: () => void;
    filterId: PaginationView;
    onApply?: () => void;
}

export const FilterDrawerBenefits: React.FC<Props> = ({ visible, onClose, filterId, onApply }) => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const tenant = useSelector(isTenantSelector);
    const formInitial = useSelector((state: AppState) => getFilterParams(state, filterId));

    const handleSaveFilters = (filters: PaginationFilters) => {
        dispatch(saveFilters({ ...filters, path: pathname }));
        onClose();
        if (onApply) {
            setTimeout(() => onApply(), 50);
        }
    };

    const handleClearFilters = (view?: PaginationView) => {
        dispatch(clearFilters(view || filterId));
        onClose();
        if (onApply) {
            setTimeout(() => onApply(), 50);
        }
    };

    return (
        <FilterDrawer visible={visible} onClose={onClose} title="Filter Benefits">
            {visible && (
                <BenefitsFilter
                    tenant={tenant}
                    filterId={filterId}
                    backUrl={pathname}
                    formInitial={formInitial}
                    saveFilters={handleSaveFilters}
                    clearFilters={handleClearFilters}
                />
            )}
        </FilterDrawer>
    );
};
